import actions from "./support-actions";
import mutations from "./support-mutations";
const SupportStore = {
  namespaced: true,
  state: {
    faq: []
  },
  mutations,
  actions
};
export default SupportStore;